import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CALENDLY_URL } from "@/lib/scroll";

const FinalCta = () => (
  <section
    data-testid="final-cta-section"
    className="relative overflow-hidden bg-ink py-24 text-center lg:py-32"
  >
    <div className="pointer-events-none absolute left-1/2 top-0 h-96 w-[42rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-terra/25 blur-3xl" />
    <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-12">
      <Reveal>
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-gold">
          Final call to action
        </p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-7 font-serif text-4xl font-semibold leading-[1.1] tracking-tight text-cream sm:text-5xl lg:text-6xl">
          Only <em className="italic text-terra">3 pilot slots.</em>
        </h2>
      </Reveal>
      <Reveal delay={0.16}>
        <p className="mt-6 font-serif text-xl italic text-cream/80 sm:text-2xl">
          Book a 15-minute fit call.
        </p>
      </Reveal>
      <Reveal delay={0.24}>
        <a
          href={CALENDLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="final-cta-button"
          className="mt-10 inline-flex items-center gap-2 rounded-full bg-terra px-9 py-4 text-base font-medium tracking-wide text-white shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:bg-terra-dark"
        >
          Book a 15-minute fit call
          <ArrowRight className="h-4 w-4" />
        </a>
        <p
          className="mt-7 font-mono text-[11px] uppercase tracking-[0.18em] text-cream/50"
          data-testid="final-cta-note"
        >
          Pilot price $149 · First 3 founders only
        </p>
      </Reveal>
    </div>
  </section>
);

export default FinalCta;
